import React, { useContext } from 'react';
import classNames from 'classnames';
import { enrollmentContext } from '../../../context/enrollment/enrollment-context';
import { updateValue } from '../common-functions';
import { IInputProps } from '../input';
import { InputLabel } from '../common-components/input-label';
import { ErrorShower } from '../common-components/error-shower';

export const Calendar: React.FC<IInputProps> = ({
	label,
	name,
	type,
	required,
	max,
	maxLength,
	minLength,
	placeholder,
	help,
	ariaLabel,
	className,
	errors,
	register,
}) => {
	const enrollmentCtxt = useContext(enrollmentContext);

	return (
		<div
			className={classNames('relative', {
				[`${className}`]: !!className,
			})}>
			<InputLabel
				ariaLabel={ariaLabel}
				label={label}
				required={required}
				errors={errors}
				name={name}
				help={help}
				type="calendar"
			/>
			{errors && errors[name as string] && (
				<span className="absolute h-9 inline-block bg-white input-warning lg:leading-4 lg:text-body-xl md:leading-3 md:text-body-md right-0.5 rounded-r top-0.5 w-10"></span>
			)}
			<input
				className={
					'rounded-full focus:border-main lg:leading-4 font-semibold md:leading-3'
				}
				type={type ? type : 'text'}
				name={name}
				max={max}
				maxLength={maxLength}
				minLength={minLength}
				placeholder={placeholder}
				ref={register({ required })}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
					updateValue(enrollmentCtxt, name, event.target.value)
				}
			/>
			<ErrorShower errors={errors} name={name} />
		</div>
	);
};
